import { AddRankSuffix } from '~/components/utils/formatters';
import type { PlayerPoolMember } from '~/domains/contest/domains/services/interfaces/player-pool-member.interface';

import type { PlayerInfo } from '../../types/player';

import { formatNextGame } from './utils';

const parseScheduledTeamSport = (pick: PlayerPoolMember): Partial<PlayerInfo> => {
  const nextPlay = pick.attributes?.gameStartDateTime
    ? formatNextGame(new Date(pick.attributes?.gameStartDateTime))
    : undefined;

  return {
    nextPlay,
    opposingTeam: pick.attributes?.opposingTeam?.alias,
    game: pick.attributes?.game
      ? {
          currentTeamId: pick.attributes.game.currentTeamId,
          home: pick.attributes.game.home,
          away: pick.attributes.game.away,
        }
      : undefined,
    meta: pick.stats
      ? pick.stats
      : [
          {
            label: 'PROJ',
            value:
              typeof pick.attributes?.projectedFantasyPoints === 'number'
                ? pick.attributes?.projectedFantasyPoints.toFixed(2)
                : '-',
          },
          {
            label: 'OPRK',
            value: pick.attributes?.opposingTeam?.ranking
              ? AddRankSuffix(pick.attributes.opposingTeam?.ranking)
              : '-',
            variant:
              pick.attributes?.opposingTeam?.ranking !== 0 &&
              pick.attributes?.opposingTeam?.ranking < 10
                ? 'looser'
                : undefined,
          },
          {
            label: 'TEAM',
            value: pick.attributes?.team?.alias ?? '-',
          },
        ],
  };
};

export default parseScheduledTeamSport;
